import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SortControls = ({ sortBy, sortOrder, onSortChange }) => {
  const sortOptions = [
    { value: 'completion', label: 'Completion %', icon: 'TrendingUp' },
    { value: 'name', label: 'Character Name', icon: 'User' },
    { value: 'content', label: 'Content Area', icon: 'Map' }
  ];

  const handleSort = (value) => {
    if (sortBy === value) {
      onSortChange(value, sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      onSortChange(value, 'desc');
    }
  };

  return (
    <div className="bg-card rounded-xl p-4 border border-border shadow-warm mb-4 md:mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <span className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Icon name="ArrowUpDown" size={16} />
          Sort by:
        </span>
        <div className="flex flex-wrap gap-2">
          {sortOptions?.map((option) => (
            <Button
              key={option?.value}
              variant={sortBy === option?.value ? 'default' : 'outline'}
              size="sm"
              onClick={() => handleSort(option?.value)}
              iconName={option?.icon}
              iconPosition="left"
              className="text-xs"
            >
              {option?.label}
              {sortBy === option?.value && (
                <Icon 
                  name={sortOrder === 'asc' ? 'ChevronUp' : 'ChevronDown'} 
                  size={14} 
                  className="ml-1"
                />
              )}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SortControls;